import { memo } from 'react';
import { type NodeProps } from 'reactflow';
import { Copy } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const DuplicateDetectorNode = memo(({ data, selected }: NodeProps) => (
    <BaseNodeUI
        title={data?.label || 'Duplicate Detector'}
        icon={Copy}
        colorClass="from-red-500 to-red-700"
        bgClass="bg-gradient-to-br from-red-500 to-red-700"
        selected={selected}
        isRunning={data?.executionStatus === 'Running'}
        executionStatus={data?.executionStatus}
        isSource={false}
        isTarget={true}
        rowsProcessed={data?.rowsAffected}
    />
));
DuplicateDetectorNode.displayName = 'DuplicateDetectorNode';
export default DuplicateDetectorNode;
